import config from 'config'
import { Logger } from '@vue-storefront/core/lib/logger';

export default function filterAttributes ({
  filterValues,
  filterField,
  blacklist,
  idsList,
  codesList
}: {
  filterValues: string[],
  filterField: string,
  blacklist: string[],
  idsList: any,
  codesList: any
}) {
  if (!Array.isArray(filterValues)) {
    Logger.warn('filterValues is not a valid array. Returning an empty array.', 'helpers/filterValues/filterAttributes', filterValues);
    return [];
  }
  return filterValues.filter(fv => {
    if (typeof fv === 'string' && fv.indexOf('.') >= 0) {
      return false
    }
    if (blacklist && Array.isArray(blacklist) && blacklist.includes(fv)) {
      return false
    }
    if (filterField === 'attribute_id') {
      return (typeof idsList[fv] === 'undefined' || idsList[fv] === null)
    }
    if (filterField === 'attribute_code') {
      return (typeof codesList[fv] === 'undefined' || codesList[fv] === null)
    }
  })
}
